// import { useEffect, useState, useCallback } from "react";
// import { toast } from "react-toastify";
// import { getSubscriptionsApi } from "../../apis/subscriptionApi";

// export const useSubscriptions = (page, pageSize = 5) => {
//   const [subscriptions, setSubscriptions] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const fetchSubscriptions = useCallback(async (silent = false) => {
//     setLoading(true);

//     let toastId = null;
//     if (!silent) {
//       toastId = toast.loading("Loading subscriptions...");
//     }

//     try {
//       const data = await getSubscriptionsApi(page, pageSize);
//       if (data?.data) {
//         setSubscriptions(data.data);
//       } else {
//         setSubscriptions([]);
//       }

//       if (toastId) {
//         toast.update(toastId, {
//           // render: "Subscriptions loaded",
//           type: "success",
//           isLoading: false,
//           autoClose: 1500,
//         });
//       }
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to fetch subscriptions";

//       if (toastId) {
//         toast.update(toastId, {
//           render: errorMessage,
//           type: "error",
//           isLoading: false,
//         });
//       } else {
//         toast.error(errorMessage);
//       }

//       console.error("Failed to fetch subscriptions:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [page, pageSize]);

//   useEffect(() => {
//     fetchSubscriptions(true); // silent on initial load / page change
//   }, [fetchSubscriptions]);

//   // Optional: public refetch method
//   const refetch = () => fetchSubscriptions(false);

//   return { subscriptions, loading, setSubscriptions, refetch };
// };
import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { getSubscriptionsApi } from "../../apis/subscriptionApi";

export const useSubscriptions = (page, pageSize = 5) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
  // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to fetch subscriptions.",
    };
  };

  const fetchSubscriptions = useCallback(async (silent = false) => {
    setLoading(true);
    setError(null);

    let toastId = null;
    if (!silent) {
      toastId = toast.loading("Loading subscriptions...");
    }

    try {
      const data = await getSubscriptionsApi(page, pageSize);
      setSubscriptions(data?.data || []);

      if (toastId) {
        toast.update(toastId, {
          render: (
            <div>
              <strong>Subscriptions Loaded</strong>
              <div>Subscriptions fetched successfully.</div>
            </div>
          ),
          type: "success",
          isLoading: false,
          autoClose: 1500,
        });
      }
    } catch (err) {
      const { title, issue } = extractError(err);

      if (toastId) {
        toast.update(toastId, {
          render: (
            <div>
              <strong>{title}</strong>
              <div>{issue}</div>
            </div>
          ),
          type: "error",
          isLoading: false,
        });
      } else {
        toast.error(
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        );
      }

      setError({ title, issue });
    } finally {
      setLoading(false);
    }
  }, [page, pageSize]);

  useEffect(() => {
    fetchSubscriptions(true);
  }, [fetchSubscriptions]);

  const refetch = () => fetchSubscriptions(false);

  return { subscriptions, loading, error, setSubscriptions, refetch };
};